import { MetabaseEmbedType } from './metabase.types';
import { useApiQuery } from '../../hooks';

export function useMetabaseEmbed() {
  return useApiQuery<MetabaseEmbedType>(
    `ui/metabase/embed`,
    ['metabase-embed'],
    {
      refetchInterval: 1000 * 40 * 60, // 40 minutes
    }
  );
}
